import { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import HomePage from "./pages/Home";

import ManagePostcardsPage from "./pages/ManagePostcards";
import PostcrossingImportPage from "./pages/PostcrossingImport";
import PrepareNewPostcardsPage from "./pages/PrepareNewPostcards";
import RatingsPage from "./pages/Ratings";
import SentCardsPage from "./pages/SentCards";
import SignInPage from "./pages/SignIn";
import VerifyMagicLinkPage from "./pages/VerifyMagicLink";

// The maps page is the only importer of the atlas polygons (about 217 KB raw), so it
// loads as its own chunk — every other route stops paying for shapes it never draws.
const MapsPage = lazy(() => import("./pages/Maps"));

/**
 * The routes the Next App Router used to own, now client-side.
 *
 * The Go server falls back to index.html for anything that is not an API route or a real
 * file, so a hard refresh on /maps or /auth/verify still lands here.
 */
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/maps" element={<Suspense fallback={<main className="app-shell" />}><MapsPage /></Suspense>} />
        <Route path="/manage-postcards" element={<ManagePostcardsPage />} />
        <Route path="/prepare-new-postcards" element={<PrepareNewPostcardsPage />} />
        <Route path="/postcrossing-import" element={<PostcrossingImportPage />} />
        <Route path="/ratings" element={<RatingsPage />} />
        <Route path="/sent-cards" element={<SentCardsPage />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/auth/verify" element={<VerifyMagicLinkPage />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}
